/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddFileToSurveyInput
 */
export interface AddFileToSurveyInput {
    /**
     * 
     * @type {string}
     * @memberof AddFileToSurveyInput
     */
    surveyUUID: string;
    /**
     * 
     * @type {string}
     * @memberof AddFileToSurveyInput
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof AddFileToSurveyInput
     */
    name: string;
}

/**
 * Check if a given object implements the AddFileToSurveyInput interface.
 */
export function instanceOfAddFileToSurveyInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "surveyUUID" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function AddFileToSurveyInputFromJSON(json: any): AddFileToSurveyInput {
    return AddFileToSurveyInputFromJSONTyped(json, false);
}

export function AddFileToSurveyInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddFileToSurveyInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'surveyUUID': json['surveyUUID'],
        'type': json['type'],
        'name': json['name'],
    };
}

export function AddFileToSurveyInputToJSON(value?: AddFileToSurveyInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'surveyUUID': value.surveyUUID,
        'type': value.type,
        'name': value.name,
    };
}

